import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import { Table } from "antd";
import BaseCard from "../../components/card/BaseCard";
import { Icon } from "@iconify/react";
import BaseTable from "../../components/BaseTable";
import type { TableProps } from "antd/lib";
import StatusVisit from "../../components/StatusVisit";
import ButtonIcon from "../../components/ButtonIcon";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Link } from "react-router";
import { $api, type components } from "../../helper";
import { statusMock, tokenMock } from "../../helper/mock";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { useNotify } from "../../helper/notify";
import FilterSearch from "../../components/filter/FilterSearch";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";

export default function DepartmentCategory() {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const deleteCat = $api.useMutation("delete", "/site-api/v1/department/");
  const [id, setId] = useState("");
  const { data, isLoading, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/department/",
    {
      headers: {
        Authorization: tokenMock,
        lang: "fa",
      },
    },
  );

  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("دپارتمان ها");
  }, []);

  const columns: TableProps<
    components["schemas"]["SiteDepartmentItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "عنوان دپارتمان",
      dataIndex: "title",
      key: "title",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.title
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "تعداد دسته بندی",
      dataIndex: "categories_count",
      key: "categories_count",
    },
    {
      title: "نمایش در سایت",
      key: "show",
      dataIndex: "show",
      filters: statusMock,
      onFilter: (value, record) =>
        record.status.toString().indexOf(value as string) === 0,
      render: (_, record) => <StatusVisit status={record.status} />,
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex items-center gap-2">
          <Link
            to={`/department-category/${record.slug}`}
            className="h-full flex-center border px-3 py-1.5 rounded-lg"
          >
            زیر دسته ها
          </Link>
          {/* <ButtonLinkIcon
            to={{
              pathname: "/department-category/add-department",
              search: "?u_id=" + record.u_id,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={{
              pathname: "/department-category/add-department",
              search: "?u_id=" + record.u_id,
            }}
            className="text-primary-500!"
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setId(record.u_id);
              setIsOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        pending={deleteCat.isPending}
        title="حذف از دپارتمان ها ؟"
        description="حذف این دپارتمان باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() => {
          deleteCat.mutate(
            {
              params: {
                query: {
                  department_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                refetch();
                setId("");
                setIsOpen(false);
              },
            },
          );
        }}
        open={isOpen}
        onClose={() => {
          setId("");
          setIsOpen(false);
        }}
      />
      <div className="w-full flex justify-end sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <Link
          to={"/department-category/add-department"}
          className="button-style"
        >
          ایجاد دپارتمان
        </Link>
      </div>

      <div>
        <BaseCard props={{ className: "flex-1 flex-col flex gap-6" }}>
          <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
            <Table<components["schemas"]["SiteDepartmentItem"]>
              columns={columns}
              dataSource={data?.data}
              loading={isLoading}
              className="col-span-1!"
              scroll={{ x: "max-content" }}
            />
          </BaseTable>
        </BaseCard>
      </div>
    </div>
  );
}
